import { oktaAuthInstance } from "@/plugins/oktaPlugin";
import type { Client } from "graphql-ws";
import { createClient as createWSClient } from "graphql-ws";

export const subscriptionClient = (): Client =>
  createWSClient({
    url: window.config.GRAPHQL_WS_ENDPOINT,
    lazy: true,
    connectionParams: {
      headers: {
        Authorization: "Bearer " + oktaAuthInstance.getAccessToken()
      }
    }
  });

export const subscriptionClientPublic = (): Client =>
  createWSClient({
    url: window.config.GRAPHQL_WS_ENDPOINT,
    // reconnect: true,
    lazy: true
  });
